/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';

import type { GetRecommendationsResponse } from './recommendation-api.types';

export async function getRecommendationResults(
    searchParams: URLSearchParams,
    signal?: AbortSignal
) {
    return axios
        .get<GetRecommendationsResponse>(`/api/recommendation/recommend`, {
            params: searchParams,
            signal,
        })
        .then((response) => {
            return response.data;
        });
}
